import { Entidad } from "../../../data/Entidad";
import { _SvGruposObtenerMaestros } from "../../../data/modulo/Grupo";
import { Fields, FormGenerator, IField } from "../../controlD3/Formulario";
import { IAgendaEvent } from "../../panelCard/Grupo/GruposAgenda";
import { IMaestroAsignado } from "../../panelCard/Grupo/GruposMaestrosV2";
import { UIUtilTime } from "../../util/Time";

export function AgendaTaskActionForm(agendaTask: IAgendaEvent, action: Entidad.CAccionPermiso, idGroup: number) {
    const isEdition = action == Entidad.CAccionPermiso.Editar;

    let dataToForm: IAgendaEvent = <IAgendaEvent>{
        ...agendaTask,
    }

    if (isEdition) {
        dataToForm.StrStart = agendaTask?.StrStart ? UIUtilTime._FmtToInputDate(agendaTask?.StrStart) : null
    } else {
        dataToForm.StrStart = UIUtilTime._FmtToInputDate(new Date())
    }

    let schema: Array<IField<IAgendaEvent>> = [
        {
            type: Fields.input,
            model: "Name",
            labelText: "lbl_activity",
            inputAttr: {
                required: true,
            }
        },
        {
            type: Fields.input,
            model: "StrStart",
            labelText: "lbl_date",
            inputAttr: {
                type: "date",
                required: true,
                min: UIUtilTime._FmtToInputDate(new Date())
            }
        }
    ];

    if (!isEdition) {
        schema.push({
            type: Fields.selectMaterial,
            model: "IdOrigin",
            labelText: "lbl_teacher",
            selectMaterialAttr: {
                required: true,
                Data: () => GetGroupTeachers(idGroup),
                valueMember: "IdMaestro",
                displayMember: "NombreCompleto"
            }
        })
    }

    return new FormGenerator<IAgendaEvent>()
        ._Crear({
            LabelMaxWidth: 100,
            LangModuleKeyInContext: "grupopanelagenda",
            schema: schema,
        }, dataToForm);
}

export async function GetGroupTeachers(idGroup: number): Promise<IMaestroAsignado[]> {
    let resTeachers = await _SvGruposObtenerMaestros(idGroup);
    let maestrosList: IMaestroAsignado[] = (resTeachers.Datos || []).map(d => ({
        ...d,
        NombreCompleto: [d.Nombre, d.ApPaterno, d?.ApMaterno].filter(d => !!d).join(" "),
    }));

    return maestrosList;
}